module.exports = __webpack_public_path__ + "img/color-en-logo.4fb34ae8.svg";